export default function Home() {
  return <h1>🏠 security Page</h1>;
}